import "./App.css";

import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Home     from "./pages/Home";
import About    from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Contact  from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/"         element={<Home />}     />
        <Route path="/about"    element={<About />}    />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact"  element={<Contact />}  />
        <Route path="*"         element={<Navigate replace to="/" />} />
      </Routes>
    </>
  );
}

export default App;
